import { PaymentTransactionsDto } from '../../pages/users/api/dto/get/PaymentTransactionsDto'
import { PaymentTransactionsUI } from '../../pages/users/model/PaymentTransactionsUI'
import Debts from './Debts'
import Payments from './Payments'

class PaymentTransactions {
  private constructor(totalDebt: number, debts: Debts, payments: Payments) {
    this.totalDebt = totalDebt
    this.debts = debts
    this.payments = payments
  }

  private readonly totalDebt: number
  private readonly debts: Debts
  private readonly payments: Payments

  toPaymentTransactionsUI(): PaymentTransactionsUI {
    return {
      totalDebt: this.totalDebt,
      debts: this.debts.toDebtsUI(),
      payments: this.payments.toPaymentsUI(),
    } satisfies PaymentTransactionsUI
  }

  static fromDto(
    paymentTransactionsDto: PaymentTransactionsDto,
  ): PaymentTransactions {
    const { totalDebt, debts, payments } = paymentTransactionsDto
    return new PaymentTransactions(
      totalDebt,
      Debts.fromDto(debts),
      Payments.fromDto(payments),
    )
  }
}

export default PaymentTransactions
